import React, { useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { API_URL } from "../config";

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("pending"); // pending, success, error
  const [error, setError] = useState(null);
  const email = searchParams.get("email");

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/voice-preferences/unsubscribe`, { email });
      setStatus("success");
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to unsubscribe");
      setStatus("error");
    }
  };

  if (!email) {
    return (
      <div className="p-4 max-w-md mx-auto mt-10">
        <div className="bg-red-100 text-red-700 p-4 rounded">
          Invalid unsubscribe link. Please check your email and try again.
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-md mx-auto mt-10">
      <div className="bg-white p-6 rounded-lg">
        <h1 className="text-2xl font-bold mb-4">Unsubscribe Confirmation</h1>
        {status === "pending" && (
          <>
            <p className="mb-4">
              Are you sure you want to unsubscribe {email} from AI load
              notifications?
            </p>
            <button
              onClick={handleUnsubscribe}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Confirm Unsubscribe
            </button>
          </>
        )}
        {status === "success" && (
          <div className="text-green-600">
            You have been successfully unsubscribed from AI load notifications.
          </div>
        )}
        {status === "error" && <div className="text-red-600">{error}</div>}
      </div>
    </div>
  );
};

export default Unsubscribe;
